module.exports = __webpack_public_path__ + "img/articletop_lg.938f14b8.png";